import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { setupFetchInterceptor } from './lib/setupFetchInterceptor';

// Setup global fetch interceptor for 401 handling
setupFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<App />);
